<template>
  <form ref="form" action="./" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="test_type" :value="abtestType" />
    <div class="l-page l-page--abtest-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 v-if="!initialAbtest" class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</h2>
            <h2 v-if="initialAbtest" class="c-title__text c-title__text--blue u-fs34">配信メッセージの編集</h2>
            <div v-if="abtestType == abtestTypeValues.Message" class="c-text">【コンテンツ比較のA/Bテスト】</div>
            <div v-if="abtestType == abtestTypeValues.Timezone" class="c-text">【曜日・時間帯比較のA/Bテスト】</div>
            <div v-if="abtestType == abtestTypeValues.Demogra" class="c-text">【属性別配信のA/Bテスト】</div>
          </div>
          <div class="c-progress c-progress--abtest-message">
            <ul class="c-progress-list">
              <li v-if="abtestType == abtestTypeValues.Message" class="c-progress-list__item is-current">メッセージの作成<br />Aパターン</li>
              <li v-if="abtestType == abtestTypeValues.Timezone" class="c-progress-list__item is-current">メッセージの作成</li>
              <li v-if="abtestType == abtestTypeValues.Demogra" class="c-progress-list__item is-current">メッセージの作成</li>

              <li v-if="abtestType == abtestTypeValues.Message" class="c-progress-list__item">メッセージの作成<br />Bパターン</li>
              <li v-if="abtestType == abtestTypeValues.Timezone" class="c-progress-list__item">配信時間の<br />A/B設定</li>
              <li v-if="abtestType == abtestTypeValues.Demogra" class="c-progress-list__item">属性条件の<br />A/B設定</li>

              <!-- <li class="c-progress-list__item">配信条件の<br>設定</li> -->
              <li class="c-progress-list__item">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <abtest-form ref="abtestForm" v-model="abtest" />
        </div>
        <div class="l-main-content l-main-content--half l-main-content--left">
          <!-- 配信メッセージ設定 -->
          <message-form
            ref="messageForm"
            v-model="message"
            :custom-utm-parameters="customUtmParameters"
            @optimize-start="onStartOptimize"
            @optimize-end="onEndOptimize"
          />
          <message-action-form
            v-if="abtestType != abtestTypeValues.Timezone"
            ref="messageActionForm"
            v-model="messageAction"
            :skip-regular="true"
            :skip-immediate="true"
          />
        </div>
        <div class="l-main-content l-main-content--half l-main-content--right">
          <div class="p-message-preview">
            <div class="c-title c-title--left u-text-white-1">
              <div class="c-title__text u-fs--l ">プレビュー</div>
              <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
            </div>
            <ul class="c-tab-list">
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'desktop' }"
                data-type="desktop"
                @click="chengePreviewType('desktop')"
              >PCでの配信例</li>
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'mobile' }"
                data-type="mobile"
                @click="chengePreviewType('mobile')"
              >スマホでの配信例</li>
            </ul>
            <div v-show="previewType == 'desktop'" class="p-message-preview-list">
              <message-preview
                :title="message.messageTitle"
                :text="message.messageText"
                :url="message.clickUrl"
                :icon-url="previewIconUrl"
                :large-image-url="message.largeImageUrl"
                :has-button-a="message.hasButtonA"
                :has-button-b="message.hasButtonB"
                :action-button-text-a="message.actionButtonTextA"
                :action-button-text-b="message.actionButtonTextB"
              />
            </div>
            <div v-show="previewType == 'mobile'" class="p-message-preview-list">
              <message-preview-sp
                :title="message.messageTitle"
                :text="message.messageText"
                :url="message.clickUrl"
                :icon-url="previewIconUrl"
                :large-image-url="message.largeImageUrl"
                :has-button-a="message.hasButtonA"
                :has-button-b="message.hasButtonB"
                :action-button-text-a="message.actionButtonTextA"
                :action-button-text-b="message.actionButtonTextB"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn || isLoadingOptimizeImage }"
              :disabled="isLoadingSaveBtn || isLoadingOptimizeImage"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div v-if="abtest.abtestId && abtestType == abtestTypeValues.Message" class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingSkipBPatternBtn || isLoadingOptimizeImage }"
            :disabled="isLoadingSkipBPatternBtn || isLoadingOptimizeImage"
            type="button"
            name="next"
            value="next"
            @click="onSkipBPatternClick($event)"
          >
            <p class="c-btn__text">Bをスキップして確認画面へ</p>
          </button>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingNextBtn || isLoadingOptimizeImage }"
            :disabled="isLoadingNextBtn || isLoadingOptimizeImage"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p v-if="abtestType == abtestTypeValues.Message" class="c-btn__text">Bパターンの作成へ</p>
            <p v-if="abtestType == abtestTypeValues.Timezone" class="c-btn__text">曜日・時間帯A/Bの選択へ</p>
            <p v-if="abtestType == abtestTypeValues.Demogra" class="c-btn__text">属性A/Bの選択へ</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    initialAbtest: Object,
    abtestType: String,
    abtestTypeValues: Object,
    linkData: Object,
    defaultIconUrl: String,
    customUtmParameters: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      abtest: {
        abtestId: null,
        abtestName: null,
        memo: null,
      },
      message: {
        messageTitle: null,
        messageText: null,
        clickUrl: null,
        iconUrl: null,
        selectedIconFile: null,
        largeImageUrl: null,
        selectedLargeImageFile: null,
        hasButtonA: false,
        hasButtonB: false,
        actionButtonTextA: null,
        actionButtonUrlA: null,
        actionButtonTextB: null,
        actionButtonUrlB: null,
        adFlag: null,
        customUtmParameter: null,
        customUtmParameterActionA: null,
        customUtmParameterActionB: null,
      },
      messageAction: {
        requireInteraction: '0',
        sendStartDate: null,
        sendStartTime: null,
        deliverType: '1',
        regularType: [],
        regularStartDate: null,
        regularEndDate: null,
        targetStartTime: null,
      },
      errorMessage: '',
      isError: false,
      isLoadingNextBtn: false,
      isLoadingSaveBtn: false,
      isLoadingSkipBPatternBtn: false,
      isLoadingOptimizeImage: false,
      previewType: 'desktop',
    }
  },
  computed: {
    previewIconUrl: function () {
      // 不要文字(\ ")削除
      const regex = /("|\\)/g;
      const replacedUrl = this.defaultIconUrl.replace(regex, '');
      return this.message.iconUrl || replacedUrl;
    },
  },
  mounted: function() {
    import('../../funcs/pages/abtest-message-add').then(module => {
      module.AbtestMessageAdd();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    if(this.initialAbtest){
      this.abtest.abtestId = this.initialAbtest.abtest_id;
      this.abtest.abtestName = this.initialAbtest.abtest_name;
      this.abtest.memo = this.initialAbtest.memo;
      if(this.initialAbtest.abtest_messages && (this.initialAbtest.abtest_messages.length > 1)){
        let messageA = this.initialAbtest.abtest_messages[0].message;

        this.message.messageTitle = messageA.message_title;
        this.message.messageText = messageA.message_text;
        this.message.clickUrl = messageA.click_url;
        this.message.iconUrl = messageA.image_url;
        this.message.largeImageUrl = messageA.large_image_url;
        this.message.actionButtonTextA = messageA.action_button_text_a;
        this.message.actionButtonUrlA = messageA.action_button_url_a;
        this.message.actionButtonTextB = messageA.action_button_text_b;
        this.message.actionButtonUrlB = messageA.action_button_url_b;
        if(this.message.actionButtonTextA && this.message.actionButtonUrlA){
          this.message.hasButtonA = true;
        }
        if(this.message.actionButtonTextB && this.message.actionButtonUrlB){
          this.message.hasButtonB = true;
        }

        this.messageAction.requireInteraction = messageA.require_interaction;

        let messageDeliverA = messageA.message_deliver;
        if(messageDeliverA){
          this.messageAction.sendStartDate = messageDeliverA.send_start_date;
          this.messageAction.sendStartTime = this.getDisplayTime(messageDeliverA.send_start_date);
          if(messageDeliverA.regular_type){
            this.messageAction.regularType = [];
            for(let day = 0; day < 7; day++){
              if(messageDeliverA.regular_type.substring(day,day+1) == "1"){
                this.messageAction.regularType.push(''+day);
              }
            }
          }
          this.messageAction.regularStartDate = messageDeliverA.send_start_date;
          this.messageAction.regularEndDate = messageDeliverA.send_end_date;
          this.messageAction.targetStartTime = messageDeliverA.target_start_time;
        }
      }
    }
  },
  methods: {
    onSaveClick: function() {
      this.isLoadingSaveBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.listUrl,false);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
      }
    },
    onQuitClick: function() {
      location.href = this.linkData.listUrl;
    },
    onSkipBPatternClick: function(event) {
      event.preventDefault();
      this.isLoadingSkipBPatternBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.confirmUrl, true);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingSkipBPatternBtn = false; }, 300);
      }
    },
    onNextClick: function(event) {
      event.preventDefault();
      this.isLoadingNextBtn = true;

      if(this.validate()){
        if(this.abtestType == this.abtestTypeValues.Message){
          this.saveAbtest(this.linkData.messageBAddUrl,true);
          //this.$refs.form.action = this.linkData.messageBAddUrl;
        } else if(this.abtestType == this.abtestTypeValues.Timezone){
          this.saveAbtest(this.linkData.timezoneSetUrl,true);
          //this.$refs.form.action = this.linkData.timezoneSetUrl;
        } else if(this.abtestType == this.abtestTypeValues.Demogra){
          this.saveAbtest(this.linkData.demograSetUrl,true);
          //this.$refs.form.action = this.linkData.demograSetUrl;
        }
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingNextBtn = false; }, 300);
      }
    },
    validate: function() {
      let isValid = true;
      let errors = {};

      this.$refs.abtestForm.validate(errors);
      this.$refs.messageForm.validate(errors);

      if((this.abtestType == this.abtestTypeValues.Message) || (this.abtestType == this.abtestTypeValues.Demogra)){
        this.$refs.messageActionForm.validate(errors);
      }

      if(Object.keys(errors).length > 0){
        this.showErrors(errors);
        isValid = false;
      }

      return isValid;
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    appendUtmParameter(url, value) {
      let parameterValue = this.customUtmParameters[value];
      // parameterValueが存在しない、または文字列でない場合は元のURLを返す
      if (!parameterValue || typeof parameterValue !== 'string') {
        return url;
      }
      if (parameterValue.startsWith('?') || parameterValue.startsWith('&')) {
        parameterValue = parameterValue.substring(1);
      }
      url += (url.includes('?') ? '&' : '?') + parameterValue;
      return url;
    },
    saveAbtest: function(completeUrl,hasArgument) {
      let sendStartDate = null;
      let sendEndDate = null;
      let regularType = '';

      if((this.abtestType == this.abtestTypeValues.Message) || (this.abtestType == this.abtestTypeValues.Demogra)){
        if(this.messageAction.deliverType == 1){
          // 予約
          sendStartDate = moment(this.messageAction.sendStartDate).format('YYYY-MM-DD') + ' ' + this.messageAction.sendStartTime + ':00';
        } else if(this.messageAction.deliverType == 3){
          // 定期
          sendStartDate = moment(this.messageAction.regularStartDate).format('YYYY-MM-DD') + ' ' + this.messageAction.targetStartTime + ':00';
          sendEndDate = moment(this.messageAction.regularEndDate).format('YYYY-MM-DD') + ' ' + this.messageAction.targetStartTime + ':00';
          for(let day = 0; day < 7; day++){
            if(this.messageAction.regularType.includes(''+day)){
              regularType += '1';
            } else {
              regularType += '0';
            }
          }
        } else if(this.messageAction.deliverType == 4){
          // 即時
        }
      }

      let clickUrl = this.message.clickUrl;
      if (this.message.customUtmParameter) {
        clickUrl = this.appendUtmParameter(clickUrl, this.message.customUtmParameter);
      }

      let params = new FormData();
      this.appendForm(params,'abtest_id',this.abtest.abtestId);
      this.appendForm(params,'abtest_type',this.abtestType);
      this.appendForm(params,'abtest_name',this.abtest.abtestName);
      this.appendForm(params,'memo',this.abtest.memo);

      this.appendForm(params,'service_type',this.serviceType);
      this.appendForm(params,'message_title',this.message.messageTitle);
      this.appendForm(params,'message_text',this.message.messageText);
      this.appendForm(params,'click_url',clickUrl);
      this.appendForm(params,'image_url',this.message.iconUrl);
      this.appendForm(params,'large_image_url',this.message.largeImageUrl);
      this.appendForm(params,'require_interaction',this.messageAction.requireInteraction);
      if(this.message.hasButtonA){
        let actionButtonUrlA = this.message.actionButtonUrlA;
        if (this.message.customUtmParameterActionA) {
          actionButtonUrlA = this.appendUtmParameter(actionButtonUrlA, this.message.customUtmParameterActionA);
        }
        this.appendForm(params,'action_button_text_a',this.message.actionButtonTextA);
        this.appendForm(params,'action_button_url_a',actionButtonUrlA);
        if(this.message.hasButtonB){
          let actionButtonUrlB = this.message.actionButtonUrlB;
          if (this.message.customUtmParameterActionB) {
            actionButtonUrlB = this.appendUtmParameter(actionButtonUrlB, this.message.customUtmParameterActionB);
          }
          this.appendForm(params,'action_button_text_b',this.message.actionButtonTextB);
          this.appendForm(params,'action_button_url_b',actionButtonUrlB);
        }
      }
      this.appendForm(params,'group_id',this.groupId);
      this.appendForm(params,'group_name',this.newGroupName);
      this.appendForm(params,'deliver_type',this.messageAction.deliverType);
      this.appendForm(params,'send_start_date',sendStartDate);
      this.appendForm(params,'send_end_date',sendEndDate);
      this.appendForm(params,'regular_type',regularType);
      this.appendForm(params,'target_start_time',this.messageAction.targetStartTime);
      params.append('ad_flag', this.message.adFlag ? 1 : 0);
      params.append('icon_file',this.message.selectedIconFile);
      params.append('large_image_file',this.message.selectedLargeImageFile);
      axios.post('/api/abtest/save',params)
        .then(res => {
          if(this.handleResponse(res)){
            let url = completeUrl;
            if(hasArgument){
              url += '?abtest_id=' + res.data.abtest_id;
            }
            location.href = url;
          } else {
            this.isError = true;
            this.errorMessage = 'メッセージの保存に失敗しました';
          }
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // プレビューのタブを切り替える
    chengePreviewType: function(type) {
      this.previewType = type;
    },
    // 画像最適化処理の開始
    onStartOptimize: function() {
      this.isLoadingOptimizeImage = true;
    },
    // 画像最適化処理の完了
    onEndOptimize: function() {
      this.isLoadingOptimizeImage = false;
    },
  }
}
</script>
